'use client';
import { Troubleshoot } from '@mui/icons-material';
import { useApi } from '@prismo-io/core';
import useSWR from 'swr';
import useDebounceValue from '../../../helpers/use-debounce';
import { fetchExperienceName } from './fetch-experience-name';

type Props = {
  isOpen?: boolean;
  term: string | null;
};

export const useExperienceTypesAutocomplete = (props: Props) => {
  const { isOpen = true, term } = props;

  const termDebounced = useDebounceValue(term, 400);

  const { client } = useApi();

  return useSWR(
    () => (isOpen ? ['experience-name-autocomplete', termDebounced] : null),
    ([_, term]) => fetchExperienceName(client, term)
  );
};
